export default "__VITE_ASSET__edca24df__"